import { render, staticRenderFns } from "./VsDropdown.vue?vue&type=template&id=1f31739a&lang=html"
import script from "./VsDropdown.vue?vue&type=script&lang=js"
export * from "./VsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports